/**
 * Stat tile — label, value, optional secondary detail, optional meter.
 *
 * The value uses the sans face with proportional figures (a standalone number
 * looks loose in tabular figures); columns of numbers elsewhere use tabular.
 * `note` is the slot a v2 delta would occupy.
 */
export function StatTile({ label, value, unit, detail, note, mono = false, children }) {
  return (
    <div className="tile">
      <p className="tile__label">{label}</p>
      <p className={`tile__value${mono ? ' mono' : ''}`}>
        {value}
        {unit ? <span className="tile__unit">{unit}</span> : null}
      </p>
      {detail ? <p className="tile__detail">{detail}</p> : null}
      {children}
      {note ? <p className="tile__note">{note}</p> : null}
    </div>
  );
}

export function TileRow({ children, className = '' }) {
  return <div className={`tile-row ${className}`.trim()}>{children}</div>;
}
